'use client';
import React, { FC, Ref, useEffect } from 'react';

import styled from 'styled-components';

import { ExclamationCircleIcon } from '@assets/icons';
import { Modal, ModalApi, ModalProps } from '@components/Modal';
import CustomIcon from '@components/utils/CustomIcon';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 42px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding-top: 110px;
  }
`;

const ErrorLabel = styled.span`
  margin: 35.35px 0 20px;
  height: 31px;
  font-size: 24px;
  font-weight: 600;
  color: ${(p) => p.theme.palette.darkGrey};
`;

export const ErrorMessage = styled.span`
  margin-bottom: 41px;
  color: ${(p) => p.theme.palette.darkGray};
  font-size: 16px;
  line-height: 1.56;
  text-align: center;
`;
export const ErrorMessageBox = styled.span`
  color: ${(p) => p.theme.palette.coral};
  font-size: 16px;
  line-height: 1.56;
  text-align: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 12px;
  }
`;

export const Span = styled.span`
  margin-left: -10px;
  margin-top: 35px;
`;
export const SpanMobil = styled.span`
  margin-left: 27px;
`;

const StyledModal = styled(Modal)`
  padding-bottom: 0;
`;

const staticProps = {
  width: 460,
  title: null,
};

const ErrorModal: FC<
  {
    modal?: Ref<ModalApi>;
    isVisible?: boolean;
    onCancel?: () => void;
    message?: React.ReactNode;
    label?: string;
    iconSize?: number;
    labelStyle?: React.CSSProperties;
    pageOverflowRef?: React.RefObject<string>;
  } & ModalProps
> = ({
  modal,
  isVisible,
  onCancel,
  message = '',
  label = 'Hata',
  children,
  iconSize = 100,
  labelStyle,
  pageOverflowRef,
  ...rest
}) => {
  useEffect(() => {
    const body = document.querySelector('body');
    if (body) {
      body.style.overflow = 'hidden';
      return () => {
        setTimeout(() => {
          body.style.overflow = 'initial';
        }, 0);
      };
    }
  }, [pageOverflowRef]);
  return (
    <StyledModal
      isVisible={isVisible}
      onCancel={onCancel}
      ref={modal}
      {...staticProps}
      {...rest}
    >
      <Content>
        <CustomIcon icon={ExclamationCircleIcon} fontSize={iconSize} />
        {label ? <ErrorLabel style={labelStyle}>{label}</ErrorLabel> : null}
        {message ? <ErrorMessage>{message}</ErrorMessage> : null}
        {children}
      </Content>
    </StyledModal>
  );
};

export default ErrorModal;
